/** カンマ区切り文字列 ⇔ 配列。URL search param とフィルタ UI の相互変換に使う共通ヘルパ。 */
export function csvToArr(csv?: string): string[] {
  return csv ? csv.split(",").filter(Boolean) : [];
}

export function arrToCsv(arr: string[]): string | undefined {
  return arr.length ? arr.join(",") : undefined;
}
